import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DoctorProfileTypeModalPageRoutingModule } from './doctor-profile-type-modal-routing.module';

import { DoctorProfileTypeModalPage } from './doctor-profile-type-modal.page';
import { TranslateModule } from '@ngx-translate/core';
import { CustomModule } from '../customs/custom.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DoctorProfileTypeModalPageRoutingModule,
    TranslateModule,
    CustomModule
  ],
  declarations: [DoctorProfileTypeModalPage]
})
export class DoctorProfileTypeModalPageModule {}
